import { BRAND_NAME, BRAND_ASSETS } from '../data/brand';

export const Lotus = ({ className = '', size = 36 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.3" aria-hidden="true">
    <path d="M24 38C12 29 15 17 24 6c9 11 12 23 0 32Z" />
    <path d="M24 38C10 38 6 25 7 15c10 2 17 9 17 23Zm0 0c14 0 18-13 17-23-10 2-17 9-17 23Z" />
    <path d="M24 38C13 45 4 35 2 28c7-1 16 3 22 10Zm0 0c11 7 20-3 22-10-7-1-16 3-22 10Z" />
    <path d="M12 44h24" />
  </svg>
);

export const GiraffeMark = ({ className = '', id }) => (
  <img src={BRAND_ASSETS.symbol} className={`giraffe-mark ${className}`} alt="GIRAFFE gold giraffe emblem" data-testid={id} />
);

export const Logo = ({ id = 'brand-logo', onClick }) => (
  <a href="#top" data-testid={id} onClick={onClick} className="brand-logo" aria-label={`${BRAND_NAME} home`}>
    <GiraffeMark id={`${id}-giraffe`} />
    <img src={BRAND_ASSETS.wordmark} className="brand-wordmark" alt={BRAND_NAME} data-testid={`${id}-wordmark`} />
  </a>
);